angular.module('gym.invoices').controller('MarkAsPaidCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "$q", "EmploymentService", "flash", "invoice", "type", function($scope, $rootScope, $modalInstance, $http, $q, EmploymentService, flash, invoice, type) {
  var gym, handleCredit;
  gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.currency = gym.currency;
  $scope.invoice = invoice;
  $scope.type = type;
  $scope.data = {
    action: 'keep'
  };
  $scope.params = {
    approval_date: gym.today
  };
  $scope.options = [['pay_with_cash', 'Cash'], ['pay_with_pos', 'POS'], ['pay_with_other', 'Other method']];
  $scope.typeLabelMap = {
    pay_with_cash: 'cash',
    pay_with_pos: 'POS',
    pay_with_other: 'other method'
  };
  handleCredit = function() {
    var deferred, params, url;
    if ($scope.data.action === 'keep') {
      deferred = $q.defer();
      deferred.resolve();
      return deferred.promise;
    } else {
      url = $scope.data.action === 'remove' ? `/gyms/${gym.id}/credit_voucher_activities/remove_credit_from_target` : `/gyms/${gym.id}/credit_voucher_activities/refund_credit_from_target`;
      params = {
        redemption_target_type: 'Invoice',
        redemption_target_id: invoice.id
      };
      return $http.post(url, {
        credit_voucher_activity: params
      });
    }
  };
  $scope.submit = function() {
    $scope.isLoading = true;
    return handleCredit().then(function() {
      var data, url;
      data = angular.extend({}, $scope.params);
      data[$scope.type] = true;
      url = `/gyms/${gym.id}/invoices/${invoice.id}`;
      return $http.put(url, {
        invoice: data
      }).then(function() {
        flash.success = `Invoice marked as paid by ${$scope.typeLabelMap[$scope.type]}`;
        return $modalInstance.close();
      }, function(error) {
        if (error.data.error_message) {
          $scope.cancel();
          flash.error = error.data.error_message;
        } else {
          flash.error = "There was an error processing the request.";
        }
        return $scope.isLoading = false;
      });
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
